"use client";

import React from "react";

const WhyProfessionalSafer: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Why Professional Whitening Is Safer Than DIY Methods
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Over-the-counter kits look appealing &mdash; but they carry real risks
          that aren&apos;t advertised on the box.
        </p>
        <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>
            <strong>Uneven application:</strong> Generic trays leave gaps,
            allowing gel to pool in certain areas.
          </li>
          <li>
            <strong>Gum irritation:</strong> Ill-fitting trays allow whitening
            gel to leak onto soft tissues, causing chemical burns.
          </li>
          <li>
            <strong>Enamel damage from overuse:</strong> Without dentist
            guidance, patients often use strips beyond safe limits.
          </li>
          <li>
            <strong>No cavity screening:</strong> Whitening gel entering an
            undetected crack causes significant pain.
          </li>
        </ul>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          At Smile4Me Dental Care, every treatment is performed under Dr.
          Khaimov&apos;s direct supervision. Your teeth are examined before
          treatment begins. Concentration is calibrated to your enamel health,
          and protective measures are in place throughout.
        </p>

        <div className="overflow-x-auto">
          <table className="w-full max-w-3xl mx-auto border-collapse text-left text-gray-700 text-base sm:text-lg">
            <thead>
              <tr className="border-b-2 border-gray-300">
                <th className="py-3 px-4 font-semibold text-gray-800">
                  Factor
                </th>
                <th className="py-3 px-4 font-semibold text-gray-800">
                  Professional (Smile4Me)
                </th>
                <th className="py-3 px-4 font-semibold text-gray-800">
                  Over-the-Counter
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-gray-200">
                <td className="py-3 px-4 font-semibold">
                  Dentist supervision
                </td>
                <td className="py-3 px-4">&#9989; Yes</td>
                <td className="py-3 px-4">&#10060; No</td>
              </tr>
              <tr className="border-b border-gray-200">
                <td className="py-3 px-4 font-semibold">Custom tray fit</td>
                <td className="py-3 px-4">&#9989; Yes</td>
                <td className="py-3 px-4">&#10060; Generic</td>
              </tr>
              <tr className="border-b border-gray-200">
                <td className="py-3 px-4 font-semibold">
                  Cavity/restoration screening
                </td>
                <td className="py-3 px-4">&#9989; Yes</td>
                <td className="py-3 px-4">&#10060; No</td>
              </tr>
              <tr className="border-b border-gray-200">
                <td className="py-3 px-4 font-semibold">Results longevity</td>
                <td className="py-3 px-4">
                  Up to 1&ndash;2 years with maintenance
                </td>
                <td className="py-3 px-4">Weeks to a few months</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default WhyProfessionalSafer;
